import { useCapitalGlobalProposalStep1Form } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form.context';
import { FIELD_MAX_LENGTHS } from '@/shared/constants';
import { validateEmail, validatePhone } from '@/shared/utils';
import { Text } from '@noorden-insurtech/alba-design-system';

export function CapitalGlobalProposalStipulantContactSection() {
  const { form, isViewMode, shouldShowStep1FieldErrors } =
    useCapitalGlobalProposalStep1Form();

  return (
    <div className='flex flex-col gap-6'>
      <Text className='text-base font-normal text-alba-black-500'>
        Contato do Proponente
      </Text>
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
      <form.AppField
        name='stipulatorPhone'
        validators={{
          onChange: ({ value, fieldApi }) => {
            if (isViewMode) return undefined;
            if (!shouldShowStep1FieldErrors(fieldApi)) return undefined;
            if (!value?.trim()) return 'Telefone é obrigatório';
            if (!validatePhone(value)) return 'Telefone inválido';
            return undefined;
          },
        }}
        children={field => (
          <field.TextField
            label='Telefone'
            placeholder='(xx) xxxxx-xxxx'
            required
            maxLength={FIELD_MAX_LENGTHS.phone}
            mask='(99) 99999-9999'
            disabled={isViewMode}
          />
        )}
      />
      <form.AppField
        name='stipulatorEmail'
        validators={{
          onChange: ({ value, fieldApi }) => {
            if (isViewMode) return undefined;
            if (!shouldShowStep1FieldErrors(fieldApi)) return undefined;
            if (!value?.trim()) return 'E-mail é obrigatório';
            if (!validateEmail(value)) return 'E-mail inválido';
            return undefined;
          },
        }}
        children={field => (
          <field.TextField
            label='E-mail'
            lowercase
            placeholder='Digite o e-mail'
            required
            maxLength={FIELD_MAX_LENGTHS.email}
            disabled={isViewMode}
          />
        )}
      />
      </div>
    </div>
  );
}
